var map = {
	"./img1_mob@2x.png": 7044,
	"./img2_mob@2x.png": 7225,
	"./img3_mob@2x.png": 6470,
	"./img4_mob@2x.png": 6315,
	"./img5_mob@2x.png": 2328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3375;